import React from 'react';
import profilePhoto from '../../src/assets/photo.jpeg';

const Hero = () => {
  return (
    <section id="home" className="pt-20 pb-16 px-4 md:pt-32 md:pb-20">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 mb-8 md:mb-0 order-2 md:order-1 text-center md:text-left">
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-4">
            Hi, I'm <span className="text-blue-400">Monjul Boruah</span>
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-3xl mb-4 text-gray-300">
            Full Stack Developer
          </h2>
          <p className="text-base md:text-lg mb-6 text-gray-400 max-w-lg mx-auto md:mx-0">
            I build scalable web applications with modern technologies like React, Node.js, and MongoDB.
          </p>
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 justify-center md:justify-start">
            <a 
              href="#contact" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 md:py-3 rounded-lg transition text-center"
            >
              Contact Me
            </a>
            <a 
              href="https://github.com/monjulboruah" 
              target="_blank" 
              rel="noopener noreferrer"
              className="border border-blue-400 text-blue-400 hover:bg-blue-900 hover:bg-opacity-20 px-6 py-2 md:py-3 rounded-lg transition text-center"
            >
              GitHub
            </a>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-center order-1 md:order-2 mb-8 md:mb-0">
          <div className="relative w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-blue-400">
            <img
              src={profilePhoto}
              alt="Monjul Boruah"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;